
import { Inject, Ref } from "vue-property-decorator"
import { Vue, Options } from "vue-class-component"
import Tbu from "./table-box-util"

@Options({
  name: "table-box",
  props: ["modelValue"]
})
export default class TableBox extends Vue {
  @Inject() config: any
  readonly modelValue: any
  cacheEdit: any = null
  minHeight: string | null = null
  @Ref() tableRef!: any

  created() {
    const model = this.modelValue
    const { CPKit } = this.config
    if (model) {
      model.meta = {}
      model.meta.head = CPKit.copy([], Tbu.template())
      model.meta.body = [CPKit.copy([], Tbu.template()), CPKit.copy([], Tbu.template()), CPKit.copy([], Tbu.template())]
    }
  }

  mounted() {
    Tbu.editAddListener(this)
  }

  serial(i1: number, i2: number) {
    return i1 + "-" + i2
  }

  edit(evt: any, item: any) {
    if (this.cacheEdit) this.cacheEdit.edit = false
    this.cacheEdit = item
    item.edit = true
    this.minHeight = this.tableRef.offsetHeight + 5 + "px"
    this.$nextTick(() => evt.target.nextElementSibling.focus())
    evt.stopPropagation()
    evt.returnValue = false
  }

  onInputKeyup(evt: any, item: any) {
    item.text = evt.target.value
    if (["NumpadEnter", "Enter"].includes(evt.code)) {
      item.edit = false
      this.minHeight = null
    }
    evt.stopPropagation()
    evt.returnValue = false
  }

  contextmenu(evt: any) {
    if (this.cacheEdit) {
      this.cacheEdit.edit = false
      this.minHeight = null
    }
    Tbu.menuHandler(evt, this)
    evt.returnValue = false
  }
}
